import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl, headersDefault } from "./index";
import { getUserInfo, resetUserInfoThrottle } from "./userActions";

export const updateMasterClubSubscriber = createAsyncThunk(
  "initialConfiguration/updateMasterClubSubscriber",
  async (
    { id = 1, method = "PUT", payload },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const res = await fetch(
        `${baseUrl}/api/v1/master-club-subscribers/${id}`,
        {
          method,
          headers: headersDefault(),
          body: JSON.stringify(payload ?? {}),
        }
      );

      const data = await res.json().catch(() => null);

      if (!res.ok) {
        return rejectWithValue(data?.message ?? "Errore aggiornamento profilo");
      }

      // ✅ IMPORTANT: wait for refreshed profile BEFORE resolving the thunk
      try {
        resetUserInfoThrottle(); // profile just changed — force fresh fetch
        await dispatch(getUserInfo()).unwrap();
      } catch (e) {
        // non-fatal (network hiccup etc.) — but prevents most flashes when it succeeds
        console.warn("getUserInfo refresh failed after update:", e);
      }

      return data;
    } catch (e) {
      return rejectWithValue(e?.message ?? "Errore rete");
    }
  }
);
